import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { combineLatest, forkJoin, of, Subject } from 'rxjs';
import { catchError, takeUntil } from 'rxjs/operators';
import { QuestionMultipleAssignComponent } from 'src/app/Component/question-management/question-add-edit/question-multiple-assign/question-multiple-assign.component';
import { IGetCodes } from 'src/app/interfaces/codes';
import {
  IApplicableCourseResponse,
  IApplicableCoursesCategoryResponse,
  IFlashCard,
} from 'src/app/interfaces/flashCardManagement';
import {
  IQuestionsWithAnswersModifiedResponse,
  ISelectedCourses,
} from 'src/app/interfaces/questionManagement';
import { ModalService } from 'src/app/Services/confirmation-modal/modalServie.service';
import { ContentManagementService } from 'src/app/Services/content-management/content-management.service';
import {
  FlashCardManagementService,
  IFlashcardApplicableCourseCategoryList,
  IFlashcardApplicableCourseList,
} from 'src/app/Services/flashcard-management.service';
import { QuestionManagementService } from 'src/app/Services/question-management.service';
import { sameCourseValidator } from 'src/app/Validators/Validators';

@Component({
  selector: 'app-flashcard-assign-modal',
  templateUrl: './flashcard-assign-modal.component.html',
  styleUrls: ['./flashcard-assign-modal.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class FlashcardAssignModalComponent implements OnInit {
  @Input() SubjectId: number | null;
  @Input() FlashcardId: string | null;
  @Input() ScreenName: string;
  @Input() isEdit: boolean;
  @Input() currentRoute: string;
  @Input() param:string | null = null;
  @Output() openFlashCard = new EventEmitter<any>();
  @Output() clearedRoute = new EventEmitter<any>();

  assignForm: FormGroup;
  courseCategoryList: IGetCodes[];
  FlashCards: IFlashCard[] = [];
  path: string;
  private destroy$ = new Subject<void>();
  applicableCoursesCategory: IApplicableCoursesCategoryResponse[];
  applicableCourse: IApplicableCourseResponse[];
  FlashCardDifficultyLevel: IGetCodes[] = [];
  selectedQuestions: boolean[] = [];
  savedCourseSelection: ISelectedCourses | null = null;
  courseName: string | null;
  examYearName: string | null;
  examAgencyName: string | null;
  successfullySavedQuestionIds: string[] = [];
  initialFormValue: any = null;
  shouldClose: boolean = false;
  initalSelectionCleared: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    private service: ContentManagementService,
    private flashcardService: FlashCardManagementService,
    private fb: FormBuilder,
    private sanitizer: DomSanitizer,
    private readonly toaster: ToastrService,
    private modalService: ModalService,
    private cdr: ChangeDetectorRef,
    private questionService: QuestionManagementService,
    private ngModalService: NgbModal,
    private route: ActivatedRoute,
    private router: Router

  ) {}

  ngOnInit(): void {
    this.assignForm = this.fb.group({
      flashcardsArray: this.fb.array([]),
    });
    const data = {
      SubjectId: this.SubjectId,
      FlashcardID: this.FlashcardId,
      ScreenName: this.ScreenName,
    };
    const pathPayload = {
      SubjectId: this.SubjectId,
      ScreenName: 'FLASHCARD',
    };
    const applicableCourseCategoriesPayload = {
      SubjectId: this.SubjectId,
      FlashcardID: this.FlashcardId,
      ScreenName: this.ScreenName,
      SelectedIND: 'Y',
    };
    const applicableCoursePayload = {
      SubjectId: this.SubjectId,
      FlashcardID: this.FlashcardId,
      ScreenName: this.ScreenName,
      CourseID: null,
      SelectedIND: 'Y',
    };
    forkJoin([
      this.service.getDropdownListByCode('COURSE_CATEGORY_TYPE').pipe(
        catchError((err) => {
          console.error('Error fetching course category type', err);
          return of([]); // Return an empty array or fallback value
        })
      ),
      this.flashcardService.getFlashCards$(data).pipe(
        catchError((err) => {
          console.error('Error fetching flashcards', err);
          return of([]);
        })
      ),
      this.flashcardService.getPath$(pathPayload).pipe(
        catchError((err) => {
          console.error('Error fetching path', err);
          return of('');
        })
      ),
      this.flashcardService
        .getFlashCardApplicableCourseCategory$(
          applicableCourseCategoriesPayload
        )
        .pipe(
          catchError((err) => {
            console.error('Error fetching applicable courses', err);
            return of([]);
          })
        ),
      this.flashcardService.getFlashcardApplicableCourse$(
        applicableCoursePayload
      ),
      this.questionService.getQuestionRealtionType$({
        Tablename: 'QUESTION_DIFFICULTY_LEVEL_TYPE',
      }),
    ]).subscribe(
      async ([
        courseCategoryType,
        flashcards,
        path,
        applicableCourseCategories,
        applicableCourses,
        questionDiffcultyLevels,
      ]) => {
        this.applicableCoursesCategory = applicableCourseCategories;
        this.applicableCourse = applicableCourses;
        this.FlashCards = flashcards;
        this.path = path;
        this.FlashCardDifficultyLevel = questionDiffcultyLevels;
        this.courseCategoryList = courseCategoryType as IGetCodes[];
        const flashcardsArray = this.assignForm.get(
          'flashcardsArray'
        ) as FormArray;
        const patchingPromises: Promise<void>[] = [];
        this.FlashCards.forEach((flashcard, index) => {
          flashcardsArray.push(this.getFlashcardGroup(flashcard));
          this.makeCourseCategoryTypeCheckboxes(index, flashcard);
          patchingPromises.push(this.patchApplicableCourses(flashcard, index));
        });
        await Promise.all(patchingPromises);
        this.autoSelectCourse();
        this.cdr.detectChanges();
      }
    );
  }

  autoSelectCourse() {
    if (!this.initalSelectionCleared) {
      combineLatest([
        this.route.queryParams.pipe(takeUntil(this.destroy$)),
        this.service.queryParams$.pipe(takeUntil(this.destroy$)),
      ]).subscribe(([queryParams, serviceParams]) => {
        // Extract values (with fallbacks)
        const courseId = queryParams['cM_id'] || serviceParams['cM_id'];
        const courseName = queryParams['c_Name'] || serviceParams['c_Name'];
        const examAgencyId = queryParams['eA_Id'] || serviceParams['eA_Id'];
        const examAgencyName =
          queryParams['eA_Name'] || serviceParams['eA_Name'];
        const examYear = queryParams['c_id'] || serviceParams['c_id'];
        const examYearName = queryParams['eY_Name'] || serviceParams['eY_Name'];
        const categoryCode = queryParams['cC_Code'] || serviceParams['cC_Code'];
        const categoryName = queryParams['cC_Name'] || serviceParams['cC_Name'];

        // Check if all required parameters exist
        if (
          courseId &&
          courseName &&
          examAgencyId &&
          examAgencyName &&
          examYear &&
          examYearName
        ) {
          const categoryData = {
            selectedCategory: categoryCode,
            selectedCategoryName: categoryName,
            courses: [
              {
                courseId: courseId,
                courseName: courseName,
                examAgency: examAgencyId,
                examAgencyName: examAgencyName,
                examYear: examYear,
                examYearName: examYearName,
                deleteInd: 'N',
                type: categoryCode,
              },
            ],
          };
          this.resetQuestionSelections();
          // Do something with the saved values

          this.savedCourseSelection = categoryData;
          this.courseName = categoryData.courses[0].courseName;
          this.examYearName = categoryData.courses[0].examYearName;
          this.examAgencyName = categoryData.courses[0].examAgencyName;
          setTimeout(() => {
            this.disableAlreadyAssignedCheckboxes();
            this.initialFormValue = JSON.stringify(
              this.assignForm.getRawValue()
            );
            console.log('Initial Form Value:', this.initialFormValue);
          }, 0);

          this.cdr.detectChanges();
          // Use categoryData as needed
          console.log(categoryData);
          // this.categoryData = categoryData;
        }
      });
    }
  }

  hasFormChanged(): boolean {
    if (!this.initialFormValue) return false;
    const curr = this.assignForm.getRawValue();
    console.log(JSON.stringify(curr), 'Current Form Value');

    return JSON.stringify(curr) !== this.initialFormValue;
  }

  openSelectPopUp() {
    const modalRef = this.ngModalService.open(QuestionMultipleAssignComponent, {
      size: 'lg',
      centered: true,
      keyboard: true,
      backdrop: 'static',
      windowClass: 'my-custom-modal-mulitipleassign',
      backdropClass: 'my-custom-backdrop-class',
      scrollable: true,
    });

    modalRef.componentInstance.courseCategoryList = this.courseCategoryList;
    if (this.savedCourseSelection) {
      modalRef.componentInstance.initialSelection = this.savedCourseSelection;
    }
    modalRef.result
      .then((result) => {
        if (result) {
          this.savedCourseSelection = result;
          this.goToNextRoute(result);
          this.courseName = result.courses[0].courseName;
          this.examYearName = result.courses[0].examYearName;
          this.examAgencyName = result.courses[0].examAgencyName;
          setTimeout(() => {
            this.disableAlreadyAssignedCheckboxes();
          }, 0);
          this.cdr.detectChanges();
        }
      })
      .catch(() => {});
  }



      goToNextRoute(result: ISelectedCourses | null,) {
        if(!result){
          this.toaster.error('Please fill all the fields for selection', 'Error');
          return;
        }
        const examAgency =result.courses[0].examAgencyName;
        const courseName = result.courses[0].courseName;
        const examYear = result.courses[0].examYear;
        const examYearName = result.courses[0].examYearName;
        const navigationExtras: NavigationExtras = {
          queryParams: {
            c_id: result.courses[0].examYear,
            eA_Name: examAgency,
            c_Name:  courseName,
            eY_Name: examYearName,
            cM_id: result.courses[0].courseId,
            eA_Id: result.courses[0].examAgency,
            cC_Code: result.selectedCategory,
            cC_Name: result.selectedCategoryName,
          },
          skipLocationChange: false,
          state: { value: result.courses[0].examYear },
        };
        this.service.setQueryParams({
          c_id: result.courses[0].examYear,
          eA_Name: examAgency,
          c_Name: courseName,
          eY_Name: examYearName,
          cM_id: result.courses[0].courseId,
          eA_Id: result.courses[0].examAgency,
          cC_Code: result.selectedCategory,
          cC_Name: result.selectedCategory,
        });
        if (this.currentRoute) {
          if (this.param) {
            this.router.navigate([`${this.currentRoute}/${this.param}`], navigationExtras);
          } else {
            this.router.navigate([this.currentRoute], navigationExtras);
          }
        }
      }

  onFlashcardSelectedChange(flashcardIndex: number, event: Event) {
    const checked = (event.target as HTMLInputElement).checked;
    if (checked && this.savedCourseSelection) {
      this.patchSelectedCoursesToFlashcard(
        flashcardIndex,
        this.savedCourseSelection
      );
    } else {
      this.clearCourseSelectionFromFlashcard(flashcardIndex);
    }
  }

  patchSelectedCoursesToFlashcard(flashcardIndex: number, popupResult: any) {
    const flashcardGroup = this.flashcardArray.at(flashcardIndex) as FormGroup;
    // Select the correct category in the form if not already selected
    const categoryArray = flashcardGroup.get('courseCategoryType') as FormArray;
    categoryArray.controls.forEach((ctrl) => {
      if (
        ctrl.value.CourseCategoryTypeCode === popupResult.selectedCategory &&
        !ctrl.value.SelectedInd
      ) {
        ctrl.patchValue({ SelectedInd: true, isFromPopup: true });
      }
    });

    const coursesArray = flashcardGroup.get('applicableCourses') as FormArray;
    popupResult.courses.forEach((course: any) => {
      const exists = coursesArray.controls.some(
        (ctrl) =>
          ctrl.value.type === course.type &&
          ctrl.value.courseId == course.courseId &&
          ctrl.value.examAgency == course.examAgency &&
          ctrl.value.examYear == course.examYear &&
          ctrl.value.deleteInd !== 'Y'
      );
      if (!exists) {
        Promise.all([
          this.service
            .GetCode({ Tablename: `EXAM_AGENCY@${course.type}` })
            .toPromise(),
          this.service
            .GetCode({
              Tablename: `EXAM_COURSE@${course.examAgency}@Course_Category_Type@${course.type}`,
            })
            .toPromise(),
          this.service
            .GetCode({
              Tablename: `COURSE_YEAR@${course.courseId}@${course.type}`,
            })
            .toPromise(),
        ]).then(([examAgencyList, courseList, courseYear]) => {
          coursesArray.push(
            this.fb.group({
              courseId: [course.courseId, Validators.required],
              examAgency: [course.examAgency, Validators.required],
              examYear: [course.examYear, Validators.required],
              FlashcardDifficultyLevelTypeCode: ['', Validators.required],
              pastYear: [false],
              deleteInd: [course.deleteInd || 'N'],
              courseList: [courseList || []],
              courseYear: [courseYear || []],
              type: [course.type],
              examAgencyList: [examAgencyList || []],
              isFromPopup: [true],
            })
          );
          this.cdr.detectChanges();
        });
      }
    });
  }

  clearCourseSelectionFromFlashcard(flashcardIndex: number) {
    const flashcardGroup = this.flashcardArray.at(flashcardIndex) as FormGroup;
    // 1. Unselect only popup category
    const categoryArray = flashcardGroup.get('courseCategoryType') as FormArray;
    categoryArray.controls.forEach((ctrl) => {
      if (ctrl.get('isFromPopup')?.value) {
        ctrl.patchValue({ SelectedInd: false, isFromPopup: false });
      }
    });
    // 2. Remove popup courses
    const coursesArray = flashcardGroup.get('applicableCourses') as FormArray;
    for (let i = coursesArray.length - 1; i >= 0; i--) {
      if (coursesArray.at(i).get('isFromPopup')?.value) {
        coursesArray.removeAt(i);
      }
    }
  }

  disableAlreadyAssignedCheckboxes() {
    const selectedCategoryCode = this.savedCourseSelection?.selectedCategory;
    this.flashcardArray.controls.forEach((flashGroup, i) => {
      const selectedCtrl = flashGroup.get('selected');
      const courseCategoryArray = flashGroup.get(
        'courseCategoryType'
      ) as FormArray;
      if (!selectedCtrl || !courseCategoryArray) return;

      const hasMatchingCategory = courseCategoryArray.controls.some(
        (ctrl) =>
          ctrl.get('CourseCategoryTypeCode')?.value === selectedCategoryCode
      );

      const matchesPopupCourses = this.savedCourseSelection?.courses.every(
        (popupCourse) => {
          const coursesArray = flashGroup.get('applicableCourses') as FormArray;
          return coursesArray.controls.some(
            (ctrl) =>
              ctrl.get('courseId')?.value == popupCourse.courseId &&
              ctrl.get('examAgency')?.value == popupCourse.examAgency &&
              ctrl.get('examYear')?.value == popupCourse.examYear &&
              ctrl.get('type')?.value == popupCourse.type &&
              ctrl.get('deleteInd')?.value !== 'Y'
          );
        }
      );

      const shouldDisableAndCheck = hasMatchingCategory && matchesPopupCourses;

      if (shouldDisableAndCheck) {
        selectedCtrl.setValue(true, { emitEvent: false });
        selectedCtrl.disable({ emitEvent: false });
      } else {
        selectedCtrl.enable({ emitEvent: false });
        selectedCtrl.setValue(false, { emitEvent: false });
      }

      // Handle the course category checkbox too
      courseCategoryArray.controls.forEach((ctrl) => {
        const ctrlCode = ctrl.get('CourseCategoryTypeCode')?.value;
        const selectedInd = ctrl.get('SelectedInd');
        if (ctrlCode === selectedCategoryCode && selectedInd?.value === true) {
          selectedInd?.disable({ emitEvent: false });
        } else {
          selectedInd?.enable({ emitEvent: false });
        }
      });
    });
    this.cdr.detectChanges();
  }

  clearSelectedCourse() {
    this.savedCourseSelection = null;
    this.courseName = null;
    this.examYearName = null;
    this.examAgencyName = null;
    this.initalSelectionCleared = true;
    this.resetQuestionSelections();

    // Enable ALL course category checkboxes for all questions
    this.flashcardArray.controls.forEach((flashGroup) => {
      const courseCategoryArray = flashGroup.get(
        'courseCategoryType'
      ) as FormArray;
      courseCategoryArray.controls.forEach((ctrl) => {
        ctrl.get('SelectedInd')?.enable({ emitEvent: false });
      });
    });

    this.cdr.detectChanges();
  }

      clearSelectedCourseWithRoute() {
    // Clear displayed fields
    // this.courseId = '';
    // this.ExamAgencyName = '';
    // this.CourseName = '';
    // this.ExamYear = '';
    // this.globalContentParams = {};

    // Reset query params in the service
    this.service.setQueryParams({
      c_id: null,
      eA_Name: null,
      c_Name: null,
      eY_Name: null,
      eA_Id: null,
    });

    // Optional: If you want to clear query params from the URL, do this:
    this.router.navigate([], {
      queryParams: {
        c_id: null,
        eA_Name: null,
        c_Name: null,
        eY_Name: null,
        eA_Id: null,
      },
      queryParamsHandling: 'merge',
    });
    this.clearedRoute.emit(true)
    this.clearSelectedCourse()
  }


  resetQuestionSelections() {
    this.flashcardArray.controls.forEach((flashGroup) => {
      flashGroup.get('selected')?.enable({ emitEvent: false });
      flashGroup.get('selected')?.setValue(false, { emitEvent: false });
    });
    this.cdr.detectChanges();
  }

  SanitizeHTML(html: string) {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  makeCourseCategoryTypeCheckboxes(index = 0, flashCard: IFlashCard) {
    // Populate the FormArray with data
    const flashcardsArray = this.assignForm.get('flashcardsArray') as FormArray;
    const courseCategoryArray = flashcardsArray
      .at(index)
      .get('courseCategoryType') as FormArray;

    this.courseCategoryList.forEach((category) => {
      courseCategoryArray.push(
        this.fb.group({
          CourseCategoryTypeCode: category.Code,
          CourseCategoryTypeName: category.Description,
          SelectedInd: this.checkifFCCSelected(flashCard, category.Code),
          isFromPopup: false,
        })
      );
    });
  }

  disableCheckboxesAfterSave() {
    // For each flashcard, if selected is checked, disable it & its course categories
    this.flashcardArray.controls.forEach((flashGroup: AbstractControl) => {
      const selectedCtrl = flashGroup.get('selected');
      if (selectedCtrl?.value === true) {
        // Disable the selected checkbox
        selectedCtrl.disable({ emitEvent: false });
        // Disable all course category checkboxes
        const courseCategoryArray = flashGroup.get(
          'courseCategoryType'
        ) as FormArray;
        courseCategoryArray.controls.forEach((ctrl) => {
          ctrl.get('SelectedInd')?.disable({ emitEvent: false });
        });
      }
    });
    this.cdr.detectChanges();
  }

  private updateCourseCategoryCheckboxAfterDelete(
    flashcardIndex: number,
    categoryTypeCode: string
  ) {
    const flashcardGroup = this.flashcardArray.at(flashcardIndex) as FormGroup;
    const courseCategoryArray = flashcardGroup.get(
      'courseCategoryType'
    ) as FormArray;
    // Find the checkbox control for the deleted category
    const categoryCtrl = courseCategoryArray.controls.find(
      (ctrl) => ctrl.get('CourseCategoryTypeCode')?.value === categoryTypeCode
    );
    if (categoryCtrl) {
      categoryCtrl.get('SelectedInd')?.enable({ emitEvent: false });
      categoryCtrl.get('SelectedInd')?.setValue(false, { emitEvent: false });
      categoryCtrl.get('isFromPopup')?.setValue(false, { emitEvent: false });
    }
  }

  checkifFCCSelected(flashcard: IFlashCard, category: string): boolean {
    return this.applicableCoursesCategory.some(
      (e) =>
        e.Course_Category_Type_Code === category &&
        e.Flashcard_Id === flashcard.FlashCard_ID
    );
  }
  triggerParentFunction(flashcard: IFlashCard): void {
    const data = {
      FlashCard_ID: flashcard.FlashCard_ID,
      type: 'list',
      FlashcardList: this.FlashCards,
    };
    this.openFlashCard.emit(data);
  }
  getFlashcardGroup(flashcard: IFlashCard): FormGroup {
    return this.fb.group({
      selected: [false],
      courseCategoryType: this.fb.array([]),
      applicableCourses: this.fb.array([]),
      flashcardId: this.fb.control(flashcard?.FlashCard_ID),
    });
  }

  get flashcardArray(): FormArray {
    return this.assignForm.get('flashcardsArray') as FormArray;
  }

  getFormControlsForQuestion(index: number, controlName: string) {
    return (
      (this.flashcardArray.at(index).get(controlName) as FormArray) ||
      new FormArray([])
    );
  }

  logAndReturn<T>(value: T, label: string): T {
    console.log(`${label}:`, value);
    return value;
  }
  getApplicableCourseTypeElementForAQuestion(
    flashcardIndex: number,
    courseCategoryIndex: number
  ) {
    const courseCategoryArray = this.flashcardArray
      .at(flashcardIndex)
      .get('courseCategoryType') as FormArray;
    const courseCategory = courseCategoryArray.at(courseCategoryIndex);
    return courseCategory;
  }

  addApplicableCourse(flashcardIndex: number, item: IGetCodes) {
    const FlashcardFormGroup = this.flashcardArray.at(flashcardIndex);
    const applicableCourseFormArray = FlashcardFormGroup.get(
      'applicableCourses'
    ) as FormArray;
    console.log(item);
    if (this.validateExamData(applicableCourseFormArray.value, item.Code)) {
      return;
    } else {
      this.addApplicableCourses(item, applicableCourseFormArray);
    }
  }
  validateExamData(examData: any[], newType: string): boolean {
    let missingFieldsByType: Record<string, string[]> = {};
    let typeValidation: Record<string, boolean> = {};

    let validData = examData.filter((item) => item.deleteInd !== 'Y');

    validData.forEach((item: any, index: number) => {
      let errors: string[] = [];

      if (!item.examAgency) {
        errors.push('examAgency');
      }
      if (!item.courseId) {
        errors.push('courseId');
      }
      if (!item.examYear) {
        errors.push('examYear');
      }
      if (!item.FlashcardDifficultyLevelTypeCode) {
        errors.push('FlashcardDifficultyLevelTypeCode');
      }

      if (errors.length > 0) {
        if (!missingFieldsByType[item.type]) {
          missingFieldsByType[item.type] = [];
        }
        missingFieldsByType[item.type].push(
          `Row ${index + 1} (Type: ${item.type}) is missing fields`
        );
        typeValidation[item.type] = false;
      } else {
        typeValidation[item.type] = true;
      }
    });

    if (missingFieldsByType[newType] && !typeValidation[newType]) {
      this.toaster.error(
        `You cannot add a new row for type "${newType}" because existing ones have missing fields`,
        'Error',
        { timeOut: 5000 }
      );
      return true;
    }

    return false;
  }
  onCourseCategoryTypeChange(
    event: any,
    cCType: AbstractControl,
    flashcardIndex: number
  ) {
    console.log(cCType, 'form');
    if (!event.target.checked) {
      const applicableCoursesArray = this.flashcardArray
        .at(flashcardIndex)
        .get('applicableCourses') as FormArray;
      applicableCoursesArray.value.forEach((e: any, index: number) => {
        if (e.type === cCType.value.CourseCategoryTypeCode) {
          const formGroup = applicableCoursesArray.at(index);
          formGroup.get('deleteInd')?.setValue('Y');
          [
            'courseId',
            'examAgency',
            'examYear',
            'FlashcardDifficultyLevelTypeCode',
          ].forEach((field) => {
            formGroup.get(field)?.removeValidators(Validators.required);
            formGroup.get(field)?.updateValueAndValidity();
          });
        }
      });
    } else {
      const courseCategoryType = cCType.value;
      const applicableCoursesArray = this.flashcardArray
        .at(flashcardIndex)
        .get('applicableCourses') as FormArray;
      this.addApplicableCourses(
        {
          Code: courseCategoryType.CourseCategoryTypeCode,
          Description: courseCategoryType.CourseCategoryTypeCode,
          Status: 'Active',
          Display_Order: 0,
        },
        applicableCoursesArray
      );
    }
  }

  addApplicableCourses(
    courseCategoryType: IGetCodes,
    applicableCoursesFormArray: FormArray
  ) {
    this.service
      .GetCode({
        Tablename: `EXAM_AGENCY@${courseCategoryType.Code}`,
      })
      .subscribe((elem: any) => {
        applicableCoursesFormArray.push(
          this.fb.group({
            courseId: ['', Validators.required],
            examAgency: ['', Validators.required],
            examYear: ['', Validators.required],
            FlashcardDifficultyLevelTypeCode: ['', Validators.required],
            pastYear: [false],
            deleteInd: ['N'],
            courseList: [],
            courseYear: [],
            type: [courseCategoryType.Code],
            examAgencyList: [elem],
          })
        );
      });
  }

  patchApplicableCourses(
    flashcard: IFlashCard,
    flashcardIndex: number
  ): Promise<void> {
    return new Promise((resolve) => {
      if (
        this.applicableCourse.some(
          (e) => e.Flashcard_ID === flashcard.FlashCard_ID
        )
      ) {
        const aCArray = this.applicableCourse.filter(
          (e) => e.Flashcard_ID === flashcard.FlashCard_ID
        );
        const QuestionFormGroup = this.flashcardArray.at(flashcardIndex);
        const applicableCourseFormArray = QuestionFormGroup.get(
          'applicableCourses'
        ) as FormArray;

        const allObs = aCArray.map((ac) =>
          forkJoin([
            this.service.GetCode({
              Tablename: `EXAM_AGENCY@${ac?.Course_Category_Type_Code}`,
            }),
            this.service.GetCode({
              Tablename: `EXAM_COURSE@${ac.Exam_agency_ID}@Course_Category_Type@${ac.Course_Category_Type_Code}`,
            }),
            this.service.GetCode({
              Tablename: `COURSE_YEAR@${ac.Course_Master_Id}@${ac.Course_Category_Type_Code}`,
            }),
          ])
            .toPromise()
            .then(([examAgencyList, courseList, courseYear]) => {
              applicableCourseFormArray.push(
                this.fb.group({
                  courseId: [String(ac?.Course_Master_Id), Validators.required],
                  examAgency: [String(ac?.Exam_agency_ID), Validators.required],
                  FlashcardDifficultyLevelTypeCode: [
                    ac.Flashcard_Difficulty_Level_Type_Code,
                    Validators.required,
                  ],
                  examYear: [String(ac?.Course_ID), Validators.required],
                  deleteInd: [ac.Deleted_Ind],
                  courseList: [courseList],
                  courseYear: [courseYear],
                  type: [ac?.Course_Category_Type_Code],
                  examAgencyList: [examAgencyList],
                })
              );
            })
        );

        Promise.all(allObs).then(() => resolve());
      } else {
        resolve();
      }
    });
  }

  fetchCourseBasedOnExam(appInstance: any, item: any) {
    this.service
      .GetCode({
        Tablename: `EXAM_COURSE_SHORT_NAME@${appInstance.value.examAgency}@Course_Category_Type@${item.Code}`,
      })
      .subscribe((elem) => {
        appInstance.get('courseList').setValue(elem || []);
        appInstance.get('courseYear').setValue([]);
        appInstance.get('courseId').setValue(null);
        appInstance.get('examYear').setValue(null);
      });
  }
  fetchCourseYear(appExam: any, item: any) {
    this.service
      .GetCode({
        Tablename: `COURSE_YEAR@${appExam.value.courseId}@${item.Code}`,
      })
      .subscribe((elem) => {
        appExam.get('courseYear').setValue(elem || []);
        appExam.get('examYear').setValue(null);
      });
  }

  onCross() {
    if (this.hasFormChanged()) {
      this.modalService
        .open(
          'Confirmation',
          'You have unsaved changes. Do you want to save before leaving?'
        )
        .then((result: boolean) => {
          if (result) {
            this.shouldClose = true;
            this.onSave();
          } else {
            this.activeModal.close(false);
          }
        });
    } else {
      this.activeModal.close(false);
    }
  }

  checkifCategoryTypeNotEmpty(code: string, flashcardIndex: number) {
    const flashcardFormGroup = this.flashcardArray.at(flashcardIndex);
    const courseForArray = flashcardFormGroup.get(
      'applicableCourses'
    ) as FormArray;

    return !courseForArray?.value.some(
      (e: any) => e.type === code && e.deleteInd === 'N'
    );
  }
  checkifCategoryTypeNotEmptyonSave(code: string, questionIndex: number) {
    const flashcardFormGroup = this.flashcardArray.at(questionIndex);
    const courseForArray = flashcardFormGroup.get(
      'applicableCourses'
    ) as FormArray;

    return !courseForArray?.value.some(
      (e: any) => e.type === code && e.deleteInd === 'N' && e.examYear
    );
  }
  checkIfCourseYearAlreadySelected(
    applicableCourse: any,
    applicableCoursesArray: any,
    changedapplicableCoursesIndex: number
  ) {
    const notDeletedApplicableCoursesArray =
      applicableCoursesArray.value.filter((e: any) => e.deleteInd !== 'Y');
    const { duplicateIndices, hasDuplicates } =
      this.hasDuplicateCourseIdAndExamYear(
        notDeletedApplicableCoursesArray ?? []
      );

    if (hasDuplicates) {
      const duplicateIndex = applicableCoursesArray.controls.findIndex(
        (control: FormGroup) =>
          control.value.examYear === applicableCourse.value.examYear
      );

      if (duplicateIndex !== -1) {
        const fControl = applicableCoursesArray.controls[
          changedapplicableCoursesIndex
        ] as FormControl;
        const examYearControl = fControl.get('examYear');
        examYearControl?.setValue(null);
        const courseList = fControl.get('courseList')?.value;
        const courseId = fControl.get('courseId')?.value;
        const courseName =
          courseList.find((e: any) => +e.Code === +courseId)?.Description ?? '';
        this.toaster.error(
          `Course year is already selected for "${courseName}"`,
          'Error',
          { timeOut: 5000 }
        );
      }

      return;
    }
    this.disableAlreadyAssignedCheckboxes();
  }

  hasDuplicateCourseIdAndExamYear(array: any[]): {
    hasDuplicates: boolean;
    duplicateIndices: number[];
  } {
    const seen = new Map();
    const duplicateIndices: number[] = [];

    array.forEach((item, index) => {
      const key = `${item.courseId}-${item.examYear}`;

      if (seen.has(key)) {
        if (!duplicateIndices.includes(seen.get(key))) {
          duplicateIndices.push(seen.get(key));
        }
        duplicateIndices.push(index);
      } else {
        seen.set(key, index);
      }
    });

    return { hasDuplicates: duplicateIndices.length > 0, duplicateIndices };
  }

  async deleteApplicableCourseElement(
    flashcardIndex: number,
    applicableCourseFormArrayIndex: number
  ) {
    try {
      const result = await this.modalService.open(
        'Confirmation',
        'Are you sure you want to delete this Applicable Course?'
      );
      if (result) {
        const applicableCoursesArray = this.flashcardArray
          .at(flashcardIndex)
          .get('applicableCourses') as FormArray;
        const formGroup = applicableCoursesArray.at(
          applicableCourseFormArrayIndex
        ) as FormGroup;
        const categoryTypeCode = formGroup.get('type')?.value;

        if (formGroup.get('examYear')?.hasError('sameCourse')) {
          applicableCoursesArray.removeAt(applicableCourseFormArrayIndex);
          applicableCoursesArray.updateValueAndValidity();
          this.cdr.detectChanges();
        } else {
          formGroup.patchValue({ deleteInd: 'Y' });

          [
            'courseId',
            'examAgency',
            'examYear',
            'FlashcardDifficultyLevelTypeCode',
          ].forEach((field) => {
            formGroup.get(field)?.removeValidators(Validators.required);
            formGroup.get(field)?.updateValueAndValidity();
          });
        }

        // ------ NEW: Check if this was the last active row for this category ------
        const remaining = applicableCoursesArray.value.filter(
          (row: any) => row.type === categoryTypeCode && row.deleteInd !== 'Y'
        );
        if (remaining.length === 0) {
          this.updateCourseCategoryCheckboxAfterDelete(
            flashcardIndex,
            categoryTypeCode
          );
        }
        // --------------------------------------------------------------------------

        // --- Custom: If deleted course was savedCourseSelection, enable & uncheck 'selected'
        if (this.savedCourseSelection) {
          const deletedCourse = formGroup.value;
          const match = this.savedCourseSelection.courses.some(
            (sc: any) =>
              sc.courseId == deletedCourse.courseId &&
              sc.examAgency == deletedCourse.examAgency &&
              sc.examYear == deletedCourse.examYear &&
              sc.type == deletedCourse.type
          );
          if (match) {
            const flashcardGroup = this.flashcardArray.at(
              flashcardIndex
            ) as FormGroup;
            const selectedCtrl = flashcardGroup.get('selected');
            if (selectedCtrl) {
              selectedCtrl.enable({ emitEvent: false });
              selectedCtrl.setValue(false, { emitEvent: false });
            }
          }
        }
      }
    } catch (error) {}
  }

  onSave() {
    this.flashcardArray.controls.forEach((flashGroup: AbstractControl) => {
      const courseCategoryArray = flashGroup.get(
        'courseCategoryType'
      ) as FormArray;
      courseCategoryArray.controls.forEach((ctrl) => {
        // If the checkbox is disabled (i.e. read-only in UI) but checked, lock in value as true
        if (
          !ctrl.get('SelectedInd')?.enabled &&
          ctrl.get('SelectedInd')?.value
        ) {
          ctrl.get('SelectedInd')?.setValue(true, { emitEvent: false });
        }
      });
    });

    if (this.assignForm.valid) {
      const data = {
        ErrorMessage: '',
        UDTFlashcardApplicableCourseCategory:
          [] as IFlashcardApplicableCourseCategoryList[],
        UDTFlashcardApplicableCourse: [] as IFlashcardApplicableCourseList[],
      };

      const flashcardArray = this.flashcardArray.getRawValue();
      let errorOccurred = false;

      this.applicableCourse.forEach((a1Item) => {
        const matchedA2 = flashcardArray.find(
          (a2Item: any) => a2Item.flashcardId === a1Item.Flashcard_ID
        );

        if (matchedA2) {
          const exists = matchedA2.applicableCourses.some(
            (course: any) => +course.examYear === +a1Item.Course_ID
          );

          if (!exists) {
            const newCourse = {
              courseId: a1Item.Course_Master_Id,
              examAgency: a1Item.Exam_agency_ID,
              examYear: +a1Item.Course_ID,
              deleteInd: 'Y',
              courseList: [],
              courseYear: [],
              type: a1Item.Course_Category_Type_Code,
              examAgencyList: [],
            };

            matchedA2.applicableCourses.push(newCourse);
          }
        }
      });

      flashcardArray.forEach((element: any, flasCardIndex: number) => {
        element?.courseCategoryType.forEach((CC: any) => {
          if (
            this.checkifCategoryTypeNotEmptyonSave(
              CC.CourseCategoryTypeCode,
              flasCardIndex
            )
          ) {
            if (CC.SelectedInd === true) {
              this.toaster.error(
                'There are no Courses selected for ' +
                  CC.CourseCategoryTypeCode +
                  ' in Flash Card ' +
                  element.flashcardId,
                'Error',
                {
                  timeOut: 5000,
                }
              );
              errorOccurred = true;
              return;
            }
          }

          if (!errorOccurred) {
            data.UDTFlashcardApplicableCourseCategory.push({
              FlashcardID: element.flashcardId,
              CourseCategoryTypeCode: CC?.CourseCategoryTypeCode,
              SelectedIND: CC?.SelectedInd ? 'Y' : 'N',
            });
          }
        });

        if (!errorOccurred) {
          element?.applicableCourses
            .filter((e: any) => e.examYear)
            .forEach((AC: any) => {
              data.UDTFlashcardApplicableCourse.push({
                FlashcardID: element.flashcardId,
                CourseID: +AC?.examYear,
                SelectedIND: AC.deleteInd === 'Y' ? 'N' : 'Y',
                FlashcardDifficultyLevelTypeCode:
                  AC?.FlashcardDifficultyLevelTypeCode,
              });
            });
        }
      });

      if (errorOccurred) {
        return;
      }

      this.flashcardService.createUpdateApplicableFlashCard$(data).subscribe(
        (res) => {
          console.log(res);
            this.toaster.success('Saved Successfully', 'Success', {
              timeOut: 500,
            });

          this.disableCheckboxesAfterSave();

          this.initialFormValue = JSON.stringify(this.assignForm.getRawValue());
          if (this.shouldClose) {
            this.activeModal.close(false);
          }
        },
        (error) => {
          console.log(error);
          if (error.status === 304) {
            this.toaster.success('Saved Successfully', 'Success', {
              timeOut: 500,
            });
          }
        }
      );
    } else {
      this.toaster.error(`Fill out the empty higlighted fields `, 'Error', {
        timeOut: 5000,
      });
      this.assignForm.markAllAsTouched();
    }
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
